export const PACKAGE_STATUS_APPROVED = 'content-approved';
export const PACKAGE_STATUS_DRAFT = 'draft';
export const PACKAGE_STATUS_HIDDEN = 'hidden';
